import WaydValueMetricBox from "./WaydValueMetricBox";

export default WaydValueMetricBox;
